import { memo } from "react";
import { Select, SelectProps } from "antd";

const UserSelect = memo(({ ...rest }: SelectProps) => (
  <Select
    listItemHeight={60}
    notFoundContent={null}
    filterOption={false}
    showSearch
    optionLabelProp="inputLabel"
    popupClassName="user-suggestions-popup"
    placeholder="Введите email"
    {...rest}
  />
));

export default UserSelect;
